<template>
    <div>
        <q-stepper v-model="currentStep" ref="stepper">
            <q-step :title="$T('Phone Validation')" name="phone_validation">
                <phone-validation></phone-validation>
            </q-step>
            <q-step :title="$T('Order')" name="order">
                <order-form :mockData="mockData"></order-form>
            </q-step>
        </q-stepper>
    </div>
</template>

<script>

import OrderForm from "./orderForm"
import PhoneValidation from "./phoneValidation"
import { EventBus } from '../../../../plugins/event-bus'

export default {
    name: "orderStepper",

    components: {
        PhoneValidation,
        OrderForm
    },

    props: {
        mockData: Object
    },

    data() {
        return {
            currentStep: 'phone_validation'
        }
    },

    mounted() {
        EventBus.$on('nextStep', (phone_number, phone_prefix) => {
            this.mockData.phone_number = phone_number
            this.mockData.phone_prefix = phone_prefix
            this.$refs.stepper.next()

        });
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/markets/CI/pages/lending-point/orderStepper.vue